import React, { useEffect, useState } from "react";
import { Container, Modal, Table } from "react-bootstrap";
import { GetRequest } from "../../Utils/hooks/ApiHandler";
import { baseURL } from "../../Utils/constants/constant";
import useLocalStorageState from "use-local-storage-state";
import { useNavigate } from "react-router-dom";
import { formatDate } from "../../Utils/helpers/commonhelper";
import { Pagination } from "../../pages/Pagination";
import nodata from "../../Utils/assets/img/leads_no_data_found.png";
import { TableSkeleton } from "../../Utils/skeletonLoader/TableSkeleton";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload, faPlay } from "@fortawesome/free-solid-svg-icons";

function DyanmicCallLog({ show, onCloseModal, module_id, module_name }) {
  const [customer, setCustomer] = useLocalStorageState("customer", {
    token: {},
  });
  const navigate = useNavigate();
  const customerId = customer?.customer_details?.customer_id;

  const token = customer?.token?.authorization;
  const rf = customer?.token?.authentication;
  const headers = { authentication: rf, Authorization: token };
  const extras = { customer, setCustomer, rf, navigate };

  const [loading, setLoading] = useState(false);
  const [callData, setCallData] = useState([]);
  const [limit, setLimit] = useState(10);
  const [allOffset, setAllOffset] = useState(0);
  const [total_count, setTotalCount] = useState(0);

  const activeOffset = allOffset;
  const setActiveOffset = setAllOffset;
  const pageCount = Math.ceil((total_count || 0) / limit);
  // const TWILIO_ACCOUNT_SID = "AC24c92d984a4181b2f4ff0153f1993be2";
  // const TWILIO_AUTH_TOKEN = "4cd8758e42671a7f07094e0028bb191e";
  useEffect(() => {
    if (show && module_id) {
      fetchCallHistory();
    }
  }, [show, module_id, activeOffset, limit]);

  const fetchCallHistory = async () => {
    const params = { limit, offset: activeOffset };
    const query = new URLSearchParams(params).toString();
    setLoading(true);
    try {
      const res = await GetRequest(
        `${baseURL}voice/call_history/${customerId}/${module_id}/${module_name}?${query}`,
        { headers },
        extras,
      );
      if (res?.data) {
        setCallData(res?.data);
        setTotalCount(res?.total_count || 0);
      }
    } catch (error) {
      console.error("Error fetching call history:", error);
    } finally {
      setLoading(false);
    }
  };

  const handlePageChange = (selectedItem) => {
    setActiveOffset(selectedItem?.selected);
  };

  function getFutureTime12Hour(createdAt) {
    let date = new Date(createdAt);
    date.setHours(date.getHours() + 5);
    let hours = date.getHours();
    let minutes = String(date.getMinutes()).padStart(2, "0");
    let seconds = String(date.getSeconds()).padStart(2, "0");
    const ampm = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12;
    const formattedHours = String(hours).padStart(2, "0");
    return `${formattedHours}:${minutes}:${seconds} ${ampm}`;
  }

  const getStatusBadge = (status) => {
    const s = (status || "").toLowerCase();
    let bg = "#e0e0e0";
    let color = "#555";
    let dot = "#aaa";

    if (s === "completed" || s === "answered") {
      bg = "#e6f9f0";
      color = "#1a8c55";
      dot = "#1a8c55";
    } else if (s === "no-answer" || s === "not connected") {
      bg = "#fff4e5";
      color = "#d97706";
      dot = "#d97706";
    } else if (s === "busy" || s === "failed") {
      bg = "#fde8e8";
      color = "#c0392b";
      dot = "#c0392b";
    }

    return (
      <span
        style={{
          display: "inline-flex",
          alignItems: "center",
          gap: "5px",
          padding: "3px 10px",
          borderRadius: "20px",
          background: bg,
          color,
          fontSize: "12px",
          fontWeight: 600,
        }}
      >
        <span
          style={{
            width: 7,
            height: 7,
            borderRadius: "50%",
            background: dot,
            display: "inline-block",
          }}
        />
        {status || "Not Connected"}
      </span>
    );
  };

  return (
    <>
      <style>{`
        .calllog-modal .modal-content {
          border-radius: 14px;
          border: none;
          box-shadow: 0 20px 60px rgba(0,0,0,0.15);
          overflow: hidden;
          font-family: 'Poppins', sans-serif;
        }
        .calllog-modal .modal-header {
          background: linear-gradient(135deg, #1a1f36 0%, #2d3561 100%);
          border-bottom: none;
          padding: 18px 24px;
        }
        .calllog-modal .modal-title {
          color: #fff;
          font-size: 16px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 10px;
        }
        .calllog-modal .modal-title::before {
          content: '';
          display: inline-block;
          width: 10px; height: 10px;
          border-radius: 50%;
          background: #4ade80;
          box-shadow: 0 0 0 3px rgba(74,222,128,0.25);
          animation: pulse-dot 1.8s infinite;
        }
        @keyframes pulse-dot {
          0%, 100% { box-shadow: 0 0 0 3px rgba(74,222,128,0.25); }
          50% { box-shadow: 0 0 0 6px rgba(74,222,128,0.1); }
        }
        .calllog-modal .btn-close {
          filter: invert(1) brightness(2);
          opacity: 0.8;
        }
        .calllog-modal .modal-body {
          background: #f7f8fc;
          
        }
        .calllog-table thead tr th {
          background: #eef0f8;
          color: #5a607f;
          font-size: 11.5px;
          font-weight: 700;
          text-transform: uppercase;
          letter-spacing: 0.06em;
          padding: 11px 14px;
          border-bottom: 2px solid #dde1f0;
          white-space: nowrap;
        }
        .calllog-table tbody tr {
          background: #fff;
          border-bottom: 1px solid #eef0f8;
          transition: background 0.15s;
        }
        .calllog-table tbody tr:hover {
          background: #f0f3ff;
        }
        .calllog-table tbody td {
          padding: 11px 14px;
          font-size: 13px;
          color: #3a3d55;
          vertical-align: middle;
          border: none;
        }
        .calllog-table-wrap {
          border-radius: 10px;
          overflow: hidden;
          border: 1px solid #dde1f0;
          box-shadow: 0 2px 12px rgba(30,40,90,0.06);
        }
        .sno-cell {
          color: #9da3bf;
          font-size: 12px;
          font-weight: 600;
        }
        .caller-cell {
          font-weight: 600;
          color: #1a1f36;
        }
        .phone-cell {
          font-family: 'Courier New', monospace;
          font-size: 13px;
          color: #4a5568;
          letter-spacing: 0.03em;
        }
        .duration-cell {
          display: inline-flex; align-items: center; gap: 5px;
          background: #f0f3ff; color: #3b4fd8;
          border-radius: 6px; padding: 2px 8px;
          font-size: 12px; font-weight: 600;
        }
        .footer-bar {
          background: #fff;
          border-radius: 10px;
          padding: 10px 16px;
          margin-top: 14px;
          border: 1px solid #dde1f0;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          gap: 10px;
        }
        .page-info {
          font-size: 13px;
          color: #7a819e;
          margin: 0;
        }
      `}</style>

      <Modal
        show={show}
        onHide={onCloseModal}
        size="xl"
        centered
        backdrop="static"
        className="calllog-modal"
      >
        <Modal.Header closeButton>
          <Modal.Title>Call Logs</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <div className="d-flex flex-column" style={{ minHeight: "200px" }}>
            <Container
              fluid
              style={{
                fontFamily: "'Poppins', sans-serif",
                height: "calc(100vh - 15rem)",
                backgroundColor: "white",
                padding: 0,
                animation: "cardEntry 1s ease-out forwards",
              }}
              className=" p-0"
            >
              <div
                style={{
                  display: "flex",
                  flexDirection: "column",
                  height: "100%",
                  width: "100%",
                }}
              >
                <div
                  className="listStyleForContact container-table"
                  style={{
                    flex: callData?.length > 5 ? 1 : "auto",
                    overflow: "auto",
                    width: "100%",
                    maxHeight: callData?.length > 5 ? "100%" : "auto",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.scrollbarColor = "#e0e0e0 white";
                  }}
                >
                  <Table
                    hover
                    style={{
                      width: "100%",
                      minWidth: "800px",
                      marginBottom: 0,
                    }}
                  >
                    <thead style={{ zIndex: "10" }}>
                      <tr>
                        <th>S.No</th>
                        <th>Caller Name</th>
                        <th>Calling To</th>
                        <th>Date</th>
                        <th>Time</th>
                        <th>Duration</th>
                        <th>Status</th>
                        <th>Call Recording</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <TableSkeleton columnCount={7} />
                      ) : callData?.length > 0 ? (
                        callData.map((call, index) => (
                          <tr key={index}>
                            <td className="sno-cell">
                              {activeOffset * limit + index + 1}
                            </td>
                            <td className="caller-cell">
                              {call?.user_name || "N/A"}
                            </td>
                            <td className="phone-cell">+{call?.to || "N/A"}</td>
                            <td>
                              {formatDate(call?.created_at || "") || "N/A"}
                            </td>
                            <td style={{ color: "#5a607f", fontSize: 13 }}>
                              {getFutureTime12Hour(call?.created_at || "") ||
                                "N/A"}
                            </td>
                            <td>
                              <span className="duration-cell">
                                ⏱ {call?.dialcallduration || "0"} sec
                              </span>
                            </td>
                            <td>{getStatusBadge(call?.dialcallstatus)}</td>
                            <td>
                              {call?.recordingurl ? (
                                <div
                                  style={{
                                    display: "flex",
                                    gap: "12px",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  {/* Open */}
                                  <a
                                    href={call.recordingurl}
                                    target="_blank"
                                    rel="noopener noreferrer"
                                    title="Open"
                                    style={{
                                      color: "#28a745",
                                      fontSize: "16px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faPlay} />
                                  </a>

                                  {/* Download */}
                                  {/* <a
                                    href={`${call.recordingurl}.mp3`}
                                    download
                                    title="Download"
                                    style={{
                                      color: "#007bff",
                                      fontSize: "16px",
                                      cursor: "pointer",
                                    }}
                                  >
                                    <FontAwesomeIcon icon={faDownload} />
                                  </a> */}
                                </div>
                              ) : (
                                <span
                                  style={{
                                    display: "flex",
                                    gap: "12px",
                                    alignItems: "center",
                                    justifyContent: "center",
                                  }}
                                >
                                  -
                                </span>
                              )}
                            </td>
                          </tr>
                        ))
                      ) : (
                        <tr>
                          <td
                            colSpan={7}
                            style={{ textAlign: "center", padding: "2.5rem 0" }}
                          >
                            <img
                              src={nodata}
                              alt="No data"
                              style={{ width: "14rem", opacity: 0.85 }}
                            />
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </Table>
                </div>
              </div>
            </Container>
          </div>

          <div className="footer-bar" onClick={(e) => e.stopPropagation()}>
            <p className="page-info">
              Page <strong>{activeOffset + 1}</strong> of{" "}
              <strong>{pageCount || 1}</strong>
              &nbsp;·&nbsp;
              <strong>{total_count}</strong> records
            </p>
            <div style={{ display: "flex", alignItems: "center", gap: 12 }}>
              <select
                style={{ width: 72, cursor: "pointer" }}
                value={limit}
                onChange={(e) => {
                  setLimit(Number(e.target.value));
                  setActiveOffset(0);
                }}
                className="form-select form-select-sm"
              >
                <option value={10}>10</option>
                <option value={25}>25</option>
                <option value={50}>50</option>
                <option value={100}>100</option>
              </select>
              <Pagination
                offset={activeOffset}
                setOffset={setActiveOffset}
                handlePageChange={handlePageChange}
                pageCount={pageCount}
              />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default DyanmicCallLog;
